import { render } from "./CustomerDetailCashFlowTab.vue?vue&type=template&id=2e8d5f32"
import script from "./CustomerDetailCashFlowTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailCashFlowTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__